import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { createQueryClient } from './lib/query-client';
import { buildRouter } from './routes/router';

/**
 * Application root.
 *
 * The query client and router are created once in state rather than at module scope, so a test can
 * mount a fresh instance per case without cache bleeding between them.
 *
 * Session boot happens in the router's `beforeLoad` guards rather than here: resolving the session
 * before the first render is what stops a protected screen flashing before redirecting to login.
 */
export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => buildRouter(queryClient));

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
